/* ==========================================================================
   ChromaPlate — product sliders
   --------------------------------------------------------------------------
   One file for every ChromaPlate product slider on the page (featured
   collection, signs, related, recently viewed, artist). Each section
   includes this script, but it only ever runs once: the first copy sets
   window.CPFeaturedCollection and wires up every slider it can find; the
   rest see that and stop.

   The browser does the scrolling (native overflow + scroll-snap), so this
   only has to drive the arrows. Nothing here listens to touch or mouse
   movement, and the one scroll listener is passive and batched to a frame,
   so no interaction on these sliders can ever wait on script.
   ========================================================================== */
(function () {
  'use strict';
  if (window.CPFeaturedCollection) return;

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.getAttribute('data-cpfc-ready') === '1') return;
    var track = root.querySelector('.cpfc__track');
    if (!track) return;
    root.setAttribute('data-cpfc-ready', '1');

    var arrows = root.querySelector('.cpfc__arrows');
    var prev = root.querySelector('.cpfc__arrow--prev');
    var next = root.querySelector('.cpfc__arrow--next');
    if (!prev || !next) return;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    // The track snaps each card to its inner padding line, so a card's scroll
    // position is its left edge measured from that line.
    function edges() {
      var cs = getComputedStyle(track);
      var line = parseFloat(cs.scrollPaddingLeft);
      if (isNaN(line)) line = parseFloat(cs.paddingLeft) || 0;
      var base = track.getBoundingClientRect().left - track.scrollLeft + line;
      // Read live: recently-viewed builds its cards after the page loads.
      return Array.prototype.map.call(track.children, function (el) {
        return Math.round(el.getBoundingClientRect().left - base);
      });
    }

    function nearest(pos, list) {
      var best = 0, bestD = Infinity, all = list.concat([maxScroll()]);
      for (var i = 0; i < all.length; i++) {
        var d = Math.abs(all[i] - pos);
        if (d < bestD) { bestD = d; best = all[i]; }
      }
      return best;
    }

    // A page is one viewport, landed on a card edge, always moving at least
    // one card so an arrow press is never swallowed.
    function page(dir) {
      var list = edges(), max = maxScroll(), pos = track.scrollLeft;
      var dest = nearest(Math.min(max, Math.max(0, pos + dir * track.clientWidth)), list);
      var i;
      if (dir > 0 && dest <= pos + 1) {
        dest = max;
        for (i = 0; i < list.length; i++) if (list[i] > pos + 1) { dest = Math.min(list[i], max); break; }
      } else if (dir < 0 && dest >= pos - 1) {
        dest = 0;
        for (i = list.length - 1; i >= 0; i--) if (list[i] < pos - 1) { dest = Math.max(0, list[i]); break; }
      }
      track.scrollTo({ left: dest, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function update() {
      var max = maxScroll();
      if (arrows) arrows.classList.toggle('is-hidden', max <= 1);
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }

    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    update();
    // Late images (a landscape card widening) change the scroll width.
    track.addEventListener('load', schedule, { capture: true, passive: true });
    root.cpfcUpdate = schedule;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cpfc]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  window.CPFeaturedCollection = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Theme editor: a re-rendered section arrives as fresh markup.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();